export default (state, actions) => {
  return Object.assign({}, state, { ...state, data: {} });
};
